import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/shared/contexts/AuthContext";

/**
 * Ends the session and goes to the login page. Shared by the navigation's Log out (desktop) and
 * the account page's phone menu, so both log out the same way.
 */
export function useLogout() {
	const { logout } = useAuth();
	const navigate = useNavigate();

	return useCallback(async () => {
		try {
			await logout();
			navigate("/login");
		} catch (error) {
			console.error("Logout error:", error);
		}
	}, [logout, navigate]);
}
